import { useEffect, useState } from 'react';
import { WorkflowEndConfiguration } from '../../common/interfaces/workflowSession';
import { workflowEndDefaultConfig, WorkflowStatus } from '../../constants';
import { SessionStore } from '../../constants/sessionStore';

export const useWorkflowEndConfig = (): WorkflowEndConfiguration => {
  const [workflowEndConfig, setWorkflowEndConfig] = useState<WorkflowEndConfiguration>(workflowEndDefaultConfig);

  useEffect(() => {
    const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
    const endPageConfig = sessionStorage.getItem(SessionStore.endPageConfig);

    if (workflowSession && JSON.parse(workflowSession).status === WorkflowStatus.COMPLETED) {
      setWorkflowEndConfig(JSON.parse(workflowSession));
    } else if (endPageConfig) {
      setWorkflowEndConfig(JSON.parse(endPageConfig));
    }
  }, []);

  return workflowEndConfig;
};
